export default __webpack_public_path__ + "static/media/9.3e115b16.jpg";